import { memo as Memo } from 'react';

//* Components
import Image from '@components/global/Image';
import Video from '@components/cfModules/Video';

//* Styles
import TripleImageStyle from './style';

const TripleImage = Memo(({ data }) => {
	return (
		<TripleImageStyle className={'tripleImageCont'}>
			<div className={'first_img'}>
				{data.leftImage.fields.file.contentType !== 'video/mp4' ? (
					<Image
						src={data.leftImage.fields.file.url}
						alt={data.leftImage.fields.title}
					/>
				) : (
					<Video data={data.leftImage.fields.file.url} />
				)}
			</div>

			<div className={'second_img'}>
				{data.middleImage.fields.file.contentType !== 'video/mp4' ? (
					<Image
						src={data.middleImage.fields.file.url}
						alt={data.middleImage.fields.title}
					/>
				) : (
					<Video data={data.middleImage.fields.file.url} />
				)}
			</div>

			<div className={'third_img'}>
				{data.rightImage.fields.file.contentType !== 'video/mp4' ? (
					<Image
						src={data.rightImage.fields.file.url}
						alt={data.rightImage.fields.title}
					/>
				) : (
					<Video data={data.rightImage.fields.file.url} />
				)}
			</div>
		</TripleImageStyle>
	);
});

export default TripleImage;
